import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { links } from "./MyLinks";
import { FiChevronDown } from "react-icons/fi";
import { BsCardChecklist } from "react-icons/bs";
import useAxiosPrivate from '../../../../hooks/useAxiosPrivate'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'

const NavLinks = () => {
  const axiosPrivate = useAxiosPrivate()
  const [checklist, setChecklist] = useState({})
  const location = useLocation()
  const navigate = useNavigate()
  const [heading, setHeading] = useState("");
  const [subHeading, setSubHeading] = useState("");
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    let isMounted = true
    const controller = new AbortController()

    const fetchData = async () => {
      setIsLoading(true)
      try {
        const templateResponse = await axiosPrivate.get(
          'template/retrieve-checklist',
          {
            signal: controller.signal,
          },
        )

        if (isMounted) {
          setChecklist(templateResponse.data)
        }
      } catch (err) {
        if (axios.isCancel(err)) {
          // Log for debugging purposes
          // console.log('Request cancelled:', err.message);
        } else {
          console.error('Request failed:', err)
          // Only navigate if the error was not a cancellation
          // Check for a 403 status code specifically
          if (err.response && err.response.status === 403) {
            navigate('/sign-in', { state: { from: location }, replace: true })
          }
        }
      }

      setIsLoading(false)
    }

    fetchData()

    return () => {
      isMounted = false
      controller.abort()
      // console.log('Cleanup: Cancelled any ongoing requests.');
    }
  }, [navigate, location, axiosPrivate])

  //To return only the names of the category based on the template which will be highlighted
  const combinedNames = useMemo(() => {
    if (!checklist?.data) return [];
    return Object.values(checklist.data)
      .flat()
      .map(item => item.name);
  }, [checklist?.data]);

  const checkCategoryName = (name) => {
    const groupCategories =
    {
      "Purchased Goods and Services": [
        "Purchased Goods and Services",
        "Capital Goods"
      ],
      "Fuel and Energy Related": [
        "Fuel and Energy Related Activities"
      ],
      "Transportation and Distribution": [
        "Upstream Transportation and Distribution",
        "Downstream Transportation and Distribution"
      ],
      "Waste Generated": [
        "Waste Generated in Operations"
      ],
      "Employee Travels": [
        "Business Travel",
        "Employee Commuting"
      ],
      "Leased Assets": [
        "Upstream Leased Assets",
        "Downstream Leased Assets"
      ],
      "Sold Products": [
        "Processing of Sold Products",
        "Use of Sold Products",
        "End-of-Life Treatment of Sold Products"
      ],
      "Franchises & Investments": [
        "Franchises",
        "Investments"
      ]
    }
    const subcategories = groupCategories[name];
    if (!subcategories) return false

    const lowerCombined = combinedNames.map(name => name.toLowerCase());

    return subcategories.some(subcat =>
      lowerCombined.includes(subcat.toLowerCase())
    );

  }

  // if (isLoading) {
  //   return <div>Loading ... </div>// Or any loading spinner
  // }
  return (
    <>
      {links.map((link, i) => (
        <div key={i}>
          <div className="px-3 text-center group">
            <span
              className="cursor-pointer hover:bg-mainbg h-14 px-3 rounded-t-md dark:text-gray-300 dark:hover:bg-maindarkbg flex justify-between items-center text-center text-base md:pr-0 group"
              onClick={() => {
                heading !== link.name ? setHeading(link.name) : setHeading("");
                setSubHeading("");
              }}
            >
              {link.name}
              <span className="text-xl md:ml-2 md:mr-2 group-hover:rotate-180">
                <FiChevronDown />
              </span>
            </span>
            {link.submenu && (
              <div>
                <div className="absolute top-15 right-40 hidden shadow-lg group-hover:md:block hover:md:block">
                  <div className="py-3 mt-2 bg-white rounded-md py-5 pl-2 pr-8 grid grid-cols-2">
                    <div className="col-span-2 ml-6 flex items-center dark:text-black justify-center mb-3" to="/template-checklist">
                      <BsCardChecklist className="text-primary text-2xl mr-2" />
                      <span className="text-lg font-semibold uppercase hover:underline"><Link to="/template-checklist">Checklist</Link></span>
                    </div>
                    {link.sublinks.map((mysublinks, i) => (
                      <div key = {i} className={mysublinks.RowSpan}>
                        <Link className="text-lg font-semibold dark:text-black uppercase hover:underline" to={mysublinks.HeadLink} state={{ category: "" }}>
                          {mysublinks.Head}
                        </Link>
                        {mysublinks.sublink.map((slink, i) => (
                          <li key = {i} className="text-gray-600 my-2.5">
                            {slink.category ?
                              <Link className="relative hover:text-primary hover:underline hover:text-lightHoverNavbar" to={slink.link} state={{ category: slink.category }}>{slink.name}
                                {checkCategoryName(slink.name) ?
                                  <>
                                    <span className="absolute h-1.5 w-1.5 animate-ping rounded-full bg-green-500 opacity-75"></span>
                                    <span className="absolute size-1.5 rounded-full bg-green-600"></span>
                                  </> :
                                  null}
                              </Link> :
                              <Link className="hover:text-primary hover:underline hover:text-lightHoverNavbar" to={slink.link}>{slink.name}
                                {combinedNames.includes(slink.name) ?
                                  <>
                                    <span className="absolute h-1.5 w-1.5 animate-ping rounded-full bg-green-500 opacity-75"></span>
                                    <span className="absolute size-1.5 rounded-full bg-green-600"></span>
                                  </> :
                                  null}
                              </Link>

                            }

                          </li>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* Mobile menus */}
          <div
            className={`
            ${heading === link.name ? "md:hidden" : "hidden"}
          `}
          >
            {/* sublinks */}
            {link.sublinks.map((slinks, i) => (
              <div key = {i}>
                <div>
                  <h1
                    onClick={() =>
                      subHeading !== slinks.Head
                        ? setSubHeading(slinks.Head)
                        : setSubHeading("")
                    }
                    className="py-4 pl-7 font-semibold md:pr-0 pr-5 flex justify-between items-center md:pr-0 pr-5"
                  >
                    {slinks.Head}

                    <span className="text-xl md:mt-1 md:ml-2 inline">
                      <ion-icon
                        name={`${subHeading === slinks.Head
                          ? "chevron-up"
                          : "chevron-down"
                          }`}
                      ></ion-icon>
                    </span>
                  </h1>
                  <div
                    className={`${subHeading === slinks.Head ? "md:hidden" : "hidden"
                      }`}
                  >
                    {slinks.sublink.map((slink, i) => (
                      <li key = {i} className="py-3 pl-14">
                        {slink.category ?
                          <Link to={slink.link} state={{ category: slink.category }}>{slink.name}</Link> :
                          <Link to={slink.link}>{slink.name}</Link>
                        }

                      </li>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default NavLinks;